module.exports = __webpack_public_path__ + "32e842efc7eaa1f2f26ebca63401f7f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/static/background-image.jpg
// module id = 260
// module chunks = 0